import { render, staticRenderFns } from "./_price-analysis.tab.vue?vue&type=template&id=2276178c&scoped=true"
import script from "./_price-analysis.tab.vue?vue&type=script&lang=js"
export * from "./_price-analysis.tab.vue?vue&type=script&lang=js"
import style0 from "./_price-analysis.tab.vue?vue&type=style&index=0&id=2276178c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276178c",
  null
  
)

export default component.exports